if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.querySelector('.wbquicksuccess').classList.add('hidden'); // Webibazaar Quickview Message
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
          this.querySelector('.wbquicksuccess').classList.remove('hidden'); // Webibazaar Quickview Message
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Add to product-form.js

// Variant Radios Handler
if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', class VariantRadios extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
      this.variants = JSON.parse(this.querySelector('[id^="variants"]').textContent);
    }

    onVariantChange(event) {
      this.updateOptions();
      this.updateMasterIdInput();
      this.updateVariantInfo();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    updateMasterIdInput() {
      const selectedVariant = this.variants.find(variant => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });

      if (selectedVariant) {
        const masterIdInput = this.querySelector('input[name="id"]');
        if (masterIdInput) {
          masterIdInput.value = selectedVariant.id;
        }
        this.updatePageElements(selectedVariant);
      }
    }

    updateVariantInfo() {
      // Update variant labels
      this.querySelectorAll('.option-label').forEach((label) => {
        const optName = label.dataset.opt;
        const selectedInput = this.querySelector(`input[name="${optName}"]:checked`);
        if (selectedInput) {
          label.textContent = selectedInput.value;
        }
      });
    }

    updatePageElements(variant) {
      this.updatePrice(variant);
      this.updateSKU(variant);
      this.updateWeight(variant);
      this.updateInventory(variant);
      this.updateAddToCartButton(variant);
      this.updateProductImage(variant);
    }

    updatePrice(variant) {
      const priceElement = document.querySelector('[id^="price-"]');
      if (priceElement && variant.price !== undefined) {
        const formattedPrice = this.formatMoney(variant.price);
        priceElement.innerHTML = `<span class="price-item price-item--regular">${formattedPrice}</span>`;
      }
    }

    updateSKU(variant) {
      const skuElement = document.querySelector('.prod-sku');
      const skuText = skuElement?.querySelector('p');
      if (skuElement && skuText) {
        if (variant.sku) {
          skuText.textContent = variant.sku;
          skuElement.style.display = 'flex';
        } else {
          skuElement.style.display = 'none';
        }
      }
    }

    updateWeight(variant) {
      const weightElement = document.querySelector('.prod-weight');
      const weightText = weightElement?.querySelector('p');
      if (weightElement && weightText) {
        if (variant.weight > 0) {
          weightText.textContent = `${variant.weight} ${variant.weight_unit}`;
          weightElement.style.display = 'flex';
        } else {
          weightElement.style.display = 'none';
        }
      }
    }

    updateInventory(variant) {
      const inventoryElement = document.querySelector('.available-product');
      const inventoryText = inventoryElement?.querySelector('.avail-txt, .sold-txt');
      if (inventoryElement && inventoryText) {
        if (variant.available) {
          inventoryText.textContent = variant.inventory_quantity > 0 
            ? `${variant.inventory_quantity} in stock` 
            : 'In stock';
          inventoryText.className = 'avail-txt';
        } else {
          inventoryText.textContent = 'Sold out';
          inventoryText.className = 'sold-txt';
        }
      }
    }

    updateAddToCartButton(variant) {
      const addToCartBtn = document.querySelector('.product-form__submit');
      const notifyDiv = document.querySelector('.notify-sold');
      const buyBtnDiv = document.querySelector('.buy-btn');
      
      if (addToCartBtn) {
        const buttonText = addToCartBtn.querySelector('span');
        if (variant.available) {
          addToCartBtn.disabled = false;
          if (buttonText) buttonText.textContent = 'Add to cart';
          if (notifyDiv) notifyDiv.style.display = 'none';
          if (buyBtnDiv) buyBtnDiv.style.display = 'block';
        } else {
          addToCartBtn.disabled = true;
          if (buttonText) buttonText.textContent = 'Sold out';
          if (notifyDiv) notifyDiv.style.display = 'block';
          if (buyBtnDiv) buyBtnDiv.style.display = 'none';
        }
      }
    }

    updateProductImage(variant) {
      if (variant.featured_image) {
        const mainImage = document.querySelector('.product-main-item.is-active img, .product-main-item img');
        if (mainImage) {
          mainImage.src = variant.featured_image.src;
          mainImage.alt = variant.featured_image.alt || '';
        }
      }
    }

    formatMoney(cents) {
      // Simple money formatting - adjust based on your shop's format
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD' // You might want to make this dynamic
      }).format(cents / 100);
    }
  });
}

// Variant Selects Handler (for dropdown version)
if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
      this.variants = JSON.parse(this.querySelector('[id^="variants"]').textContent);
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterIdInput();
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterIdInput() {
      const selectedVariant = this.variants.find(variant => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });

      if (selectedVariant) {
        const masterIdInput = this.querySelector('input[name="id"]');
        if (masterIdInput) {
          masterIdInput.value = selectedVariant.id;
        }
        // Reuse the update methods from variant-radios
        const variantRadios = document.querySelector('variant-radios');
        if (variantRadios) {
          variantRadios.updatePageElements(selectedVariant);
        } else {
          // Create a temporary instance to use the methods
          const tempRadios = new (customElements.get('variant-radios'))();
          tempRadios.updatePageElements(selectedVariant);
        }
      }
    }
  });
}